//import '@/assets/css/style.m.css'
import '@/assets/css/global.css'
import '@/assets/css/ui.css'

import Vue from 'vue'
import App from './index.vue'

import '@/directives/index'

globalThis.mainApp = null;

//store
import store from "@/assets/js/store.js";
Vue.prototype.$store = store;

//gid
import gid from "@/assets/js/gid_config.js";
Vue.prototype.$gid = gid;

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {
    rail: {
        opacity: 0.6,
        background : '#c7def5',
        size: '6px',
        gutterOfSide : '0px',
    },
    bar: {
        background: '#4573ab',
        keepShow : true,
        size: '6px',
    }
  }, // 在这里设置全局默认配置
  name: 'vuescroll' // 在这里自定义组件名字，默认是vueScroll 
});

//引入样式
//import 'swiper/css/swiper.css'
 
//引入样式
// import style (>= Swiper 6.x)
import 'swiper/dist/css/swiper.min.css'
 
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

//tips_data

import {
  imgsPreloader
} from '@/assets/js/imgPreloader.js';
import imgPreloaderList from '@/assets/js/imgPreloaderList.js';

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

import {$get,$post} from "@/utils/axios/axios.http.js"
Vue.prototype.$get = $get
Vue.prototype.$post = $post


import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL

import BASE64 from '@/assets/js/base64.js'
Vue.prototype.$base64 = BASE64

//ajxa_map
import request_map from "@/utils/axios/map.js"
globalThis.ajax_url_map = request_map;

//login
import mslogin from '@/assets/js/msLogin.js'
Vue.prototype.$mslogin = mslogin
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login

//FREE
import Free_login from '@/assets/js/freeLogin.js';

//user_info
import User_info from '@/components/userinfo.vue';
Vue.component('user-info', User_info);

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem);

// Toast
import Toast from '@/components/Toast'
Vue.prototype.$toast = Toast

//TODO modal ui

// bind_Modal
import Bind_Modal from '@/components/AreaBind';
Vue.prototype.$bind_modal = Bind_Modal;

// Invite_Modal
import Invite_Apply from '@/components/InviteApply';
Vue.prototype.$apply_modal = Invite_Apply;

//Copy
import Copy from '@/components/CopyModal'
Vue.prototype.$copy_modal = Copy

//FriendList
import FriendList from '@/components/FriendList'
Vue.prototype.$friend_list = FriendList

//Share
import Share from '@/components/ShareModal'
Vue.prototype.$share_modal = Share

//WebApply
import WebApply from '@/components/WebApply'
Vue.prototype.$web_apply = WebApply

//Rule
import Rule from '@/components/EvtRule'
Vue.prototype.$rule_modal = Rule

//Success
import Success from '@/components/SuccessModal'
Vue.prototype.$success_modal = Success

Vue.prototype.$update_ua = function (data) {
  mainApp.ua = data;
};

Vue.prototype.$update_user = function (data) {
  mainApp.update_evt();
  mainApp.$refs.app.$refs.pass.render();
};

Vue.prototype.$update_ua_info = function (data) {
  // mainApp.ua.nickName = data.nickName;
  // mainApp.ua.areaId = data.areaId;
  mainApp.$store.commit("$_setUserinfo", data);
};

Vue.prototype.$update_evt = function (data) {
  mainApp.update_evt();
  mainApp.$refs.app.$refs.pass.render();
};

Vue.prototype.$clear_code = function(id,type){
    mainApp.$refs.app.code = '';
};

Vue.prototype.$clear_share = function(id,type){
  mainApp.$refs.app.share = '';
};
  
(async () => {
    await imgsPreloader(imgPreloaderList);
    //关闭加载弹框
    document.querySelector('.loading').style.display = 'none';
    /* eslint-disable no-new */
    mainApp = new Vue({
      el: '#app',
      components: {
        App
      },
      template: '<App ref="app" :ready="ready" :ua="ua" :evt_info="evt_info" :login="login"/>',
      data() {
        return {
          ua: {},
          evt_info: {},
          code: '',
          name: null,
          login: 0, //登陆
          aid: 0, //大区id
          account_type: 'pc',
          isLoading: false,
          ready: false, //通信阀门
          share_id : 'ME21',
          key : '',
          share : '',
          token : '',        
        }
      },
      created() {
        var _this = this;
  
        let token = GLOBAL.getQueryVariable('authorization') || localStorage.getItem("token");
        _this.token = token;
         
        let code = GLOBAL.getQueryVariable('code') || localStorage.getItem("code");
        
        this.share = GLOBAL.getQueryVariable('share') || localStorage.getItem("share");
        if(GLOBAL.getQueryVariable('share')){
          localStorage.setItem('share', this.share);
        }

        if(GLOBAL.getQueryVariable('code')){
          this.$store.commit("$_setCode", GLOBAL.getQueryVariable('code'));
          localStorage.setItem('code', code);
        }
        
        this.key = code;
 
        if (token) {
          localStorage.setItem('token', token);
          _this.$store.commit("$_setToken", token);
        }

        window.history.pushState({}, 0, GLOBAL.domain);
  
      },
      mounted (){
          this.get_user_info();
          
      
          wx.wxInit({
            title: GLOBAL.wx_share_text.title, // 分享标题
            desc: GLOBAL.wx_share_text.desc, // 分享描述
            link: GLOBAL.domain, // 分享链接
            imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
          });  
      
        },
      methods: {
        get_user_info() {
          // 调用免登录接口，进行免登录验证
          //TODO 梦平台免登录
          let _this = this;
  
          this.ua.uid = this.ua.uid || 0;
  
          Free_login.free_login_lazy(
            this.ua.uid, {
              mplat: ajax_url_map.mplat,
              kd: ajax_url_map.free,
            },
            function (response) {
              if (typeof response !== 'undefined') {
                _this.token = response.data ? response.data : response;
                localStorage.setItem('token', _this.token);
                _this.$store.commit("$_setStorage", _this.token);                
              }
              _this.update_evt();
  
            }
          );
        },
        update_login() {
          let _this = this;
  
          return new Promise((resolve, reject) => {
            _this.$axios.get(ajax_url_map.logininfo)
              .then(
                res => {
                  _this.login = 1;
                  _this.ua = res.data;
  
                  _this.$store.commit("$_setLogin", 1);
                  _this.$store.commit("$_setUserinfo", res.data);

                  if(!res.data.nickName){
                    _this.$store.commit("$_setAid", 0);
                  } 
                  
                  
  
                  resolve(res);
                  if(localStorage.getItem("code"))return this.$apply_modal({code : this.key});
                  if(this.share)this.$web_apply({code : this.share});
                  //_this.update_task ();
                },
                rej => {
                  //reject(rej);
                  this.ready = true
                  this.$toast(rej.message);
                  if(localStorage.getItem("code"))return this.$apply_modal({code : this.key});
                  if(this.share)this.$web_apply({code : this.share});
                  //_this.update_task ();
                }
              )
              .catch(function (error) {
                console.log(error);
              });
          });
  
        },
        update_evt() {
          let _this = this;

            _this.$axios.get(ajax_url_map.userinfo)
            .then(
                res => {
                    _this.evt_info = res.data;

                    _this.login = 1;
                    _this.ua = res.data;
    
                    _this.$store.commit("$_setLogin", 1);
                    _this.$store.commit("$_setUserinfo", res.data);
  
                    if(!res.data.nickName){
                      _this.$store.commit("$_setAid", 0);
                    }           


                    _this.$store.commit("$_setAccount", res.data);
                    _this.ready = true;

                    if (!res.data.zid && !localStorage.getItem("code")) {                        
                        return this.$bind_modal();
                    }

                    if(localStorage.getItem("code"))return this.$apply_modal({code : this.key});
                    if(this.share)this.$web_apply({code : this.share});
                },
                rej => {
                    _this.ready = true;
                    if(rej.code == 3 || rej.code == 4 || rej.code == 9)_this.$toast(rej.message);

                    if(rej.data){
                      _this.$store.commit("$_setLogin", 1);
                      _this.$store.commit("$_setUserinfo", rej.data);
                    }

   
                    if(rej.code == 402){
                      _this.$store.commit("$_setAid", 0);
                      return this.$bind_modal();
                    }

                    if(localStorage.getItem("code"))return this.$apply_modal({code : this.key});
                    if(this.share)this.$web_apply({code : this.share});
                    //_this.update_task ();
                }
            )        
        },
        update_user (){
          let _this = this;
  
          _this.$axios.post(ajax_url_map.userinfo)
          .then(
            res => {
              _this.evt_info = res.data;
              _this.$store.commit("$_setAccount", res.data);
              _this.ready = true;
              
            },
            rej => {
              _this.ready = true;
              //_this.update_task ();
            }
          )

        },
        share_handler (){
          if(!this.$store.state.login){
              return this.$mslogin.open();
          }
          if(!this.$store.state.userinfo.areaId){
              this.$bind_modal();
              return this.$toast('请先绑定大区');
          }
          
          this.$share_modal();             
      },      
      },
    })
})();


// WEBPACK FOOTER //
// ./src/page/index/index.js